// src/pages/auth/LoginPage/index.jsx
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import authService from "../../../services/authService";
import { useUser } from "../../../contexts/UserContext";
import logo from "../../../assets/icons/logo/Logo.svg";
import "./styles.scss";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useUser();
  const stateMessage = location.state?.resetSuccess
    ? "Password reset successful. You can sign in now."
    : "";

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      remember: false,
    },
  });

  const [authError, setAuthError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // watch() →  Forgot Password
  const currentEmail = watch("email");

  const onSubmit = async (data) => {
    setAuthError("");
    setIsLoading(true);

    try {
      const response = await authService.login({
        email: data.email,
        password: data.password,
      });
      const token = response?.data.token;
      const user = response?.data.user;

      if (token) {
        localStorage.setItem("authToken", token);
      }
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        setUser(user);
      }

      navigate(location.state?.from || "/loads", { replace: true });
    } catch (error) {
      const backendMessage =
        error?.response?.data?.error || error?.message || "";

      const isCredentialIssue =
        error?.response?.status === 400 ||
        error?.response?.status === 401 ||
        /invalid|incorrect|wrong|not\sfound/i.test(
          backendMessage?.toLowerCase() || ""
        );

      if (isCredentialIssue) {
        setAuthError("Invalid email or password.");
      } else {
        setAuthError(
          backendMessage || "Unable to sign in. Please try again later."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Google Login կոճակի event
  const handleGoogleLogin = () => {
  };

  // Reset error states
  const handleInputChange = () => {
    if (authError) {
      setAuthError("");
    }
  };

  return (
    <div className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit(onSubmit)} noValidate>
        <img src={logo} alt="Logo" className="login-logo" />

        <div className="login-heading">
          <h3 className="login-title">Welcome Back!</h3>
          <p className="login-subtitle">Please enter your details to sign in</p>
        </div>

        {stateMessage && (
          <div className="login-state-message success">
            {stateMessage}
          </div>
        )}
        {authError && (
          <div className="login-state-message error">
            {authError}
          </div>
        )}

        <div className="login-fields">
          {/*  Email */}
          <div className="field">
            <label className="field-label">Email Address</label>
            <input
              type="email"
              placeholder="Enter your email"
              className="field-input"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address"
                },
                onChange: handleInputChange
              })}
              disabled={isLoading}
            />
            {errors.email && (
              <span className="field-error">{errors.email.message}</span>
            )}
          </div>

          {/*  Password */}
          <div className="field">
            <label className="field-label">Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              className="field-input"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be at least 6 characters"
                },
                onChange: handleInputChange
              })}
              disabled={isLoading}
            />
            {errors.password && (
              <span className="field-error">{errors.password.message}</span>
            )}
          </div>
        </div>

        {/*  Remember me & Forgot password */}
        <div className="login-helpers">
          <label className="checkbox">
            <input type="checkbox" {...register("remember")} />
            <span>Remember me</span>
          </label>

          <Link
            to={`/forgot-password?email=${encodeURIComponent(currentEmail || '')}`}
            className="link-primary"
          >
            Forgot Password?
          </Link>
        </div>

        {/*  Submit */}
        <button type="submit" className="btn-submit" disabled={isLoading}>
          {isLoading ? "Signing In..." : "Sign In"}
        </button>

        {/* <div className="or-divider">
          <span>Or</span>
        </div> */}

        {/*  Google login */}
        {/* <button type="button" className="btn-google" onClick={handleGoogleLogin}>
          <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </button>

        <p className="login-signup">
          Don't have an account yet? <a href="#" className="link-primary">Sign Up</a>
        </p> */}
      </form>
    </div>
  );
}
